module.exports = __webpack_public_path__ + "static/img/money.41c89f36.svg";